import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import {
	useGetRestaurantDetails,
	useUpdateRestaurantContact,
} from "../../../../queryHooks";
import { updateRestaurantContactSchema } from "../../../../validations";
import { useStore } from "../../../../zustand/store";
import CS from "../../../../services/commonService";
import PhoneNumber from "../../../common/PhoneNumber";

const ContactDetails = () => {
	const setLoading = useStore((state) => state.setLoading);
	const { slug } = useParams();

	const [isDataChanged, setIsDataChanged] = useState(false);

	const { data: dataRestaurantDetails, refetch } =
		useGetRestaurantDetails(slug);

	const {
		values: valuesContact,
		errors: errorsContact,
		handleChange: handleChangeContact,
		handleSubmit: handleSubmitContact,
		touched: touchedContact,
	} = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: dataRestaurantDetails?.data?.email || "",
			mobile:
				(dataRestaurantDetails?.data?.mobile &&
					dataRestaurantDetails?.data?.mobile) ||
				"",
		},
		validationSchema: updateRestaurantContactSchema,
		onSubmit: (value) => {
			let body = {
				...(dataRestaurantDetails?.data?.email !== value.email && {
					email: value.email?.trim(),
				}),
				...(dataRestaurantDetails?.data?.mobile !== value.mobile && {
					mobile: value.mobile,
				}),
			};
			if (Object.keys(body).length)
				updateRestaurantContact({
					id: slug,
					body,
				});
		},
	});

	useEffect(() => {
		let body = {
			...(dataRestaurantDetails?.data?.email !== valuesContact.email && {
				email: valuesContact.email?.trim(),
			}),
			...(dataRestaurantDetails?.data?.mobile !== valuesContact.mobile && {
				mobile: valuesContact.mobile,
			}),
		};

		if (Object.keys(body).length > 0) {
			setIsDataChanged(true);
		} else {
			setIsDataChanged(false);
		}
	}, [valuesContact, dataRestaurantDetails?.data]);

	const {
		mutateAsync: updateRestaurantContact,
		error: errorUpdateRestaurantContact,
		data: dataUpdateRestaurantContact,
		isLoading: loadingUpdateRestaurantContact,
	} = useUpdateRestaurantContact();

	useEffect(() => {
		if (dataUpdateRestaurantContact) {
			if (dataUpdateRestaurantContact.status === "success") {
				CS.showSuccessMessage(dataUpdateRestaurantContact.message);
				refetch();
			} else if (dataUpdateRestaurantContact.status === "fail") {
				CS.showErrorMessage(dataUpdateRestaurantContact.message);
			}
		}
	}, [dataUpdateRestaurantContact]);

	useEffect(() => {
		if (errorUpdateRestaurantContact) {
			CS.showErrorMessage(errorUpdateRestaurantContact.response?.data?.message);
		}
	}, [errorUpdateRestaurantContact]);

	useEffect(() => {
		setLoading(loadingUpdateRestaurantContact);
	}, [loadingUpdateRestaurantContact]);

	return (
		<form onSubmit={handleSubmitContact}>
			<div className="card profile-card mb-5">
				<div className="modal-header p-0 pb-3 mb-4 w-100">
					<h5 className="box-title modal-title">
						<i className="bx bx-user mr-1"></i> Contact Details
					</h5>
				</div>
				<div className="row align-items-center">
					<div className="col-md-12 mt-3">
						<div className="row">
							<div className="form-group col-md-6 mb-md-4 mb-3">
								<label className="mb-1" htmlFor="emailId">
									Email<sup className="text-danger">*</sup>
								</label>
								<div className="w-100">
									<input
										className="form-control"
										id="email"
										name="email"
										type="email"
										value={valuesContact.email}
										onChange={handleChangeContact}
									/>
								</div>
								<span className="text-danger d-block">
									{errorsContact.email && touchedContact.email
										? errorsContact.email
										: null}
								</span>
							</div>
							<div className="col-md-6">
								<label className="mb-1" htmlFor="phonelId">
									Phone Number
								</label>
								<PhoneNumber
									value={valuesContact.mobile}
									onChange={(val) => {
										let event = {
											target: {
												name: "mobile",
												value: val ? val : "",
											},
										};
										handleChangeContact(event);
									}}
								/>
								<span className="text-danger d-block">
									{errorsContact.mobile && touchedContact.mobile
										? errorsContact.mobile
										: null}
								</span>
							</div>
						</div>
						<div className="col-md-12 mt-4 btn-blocks text-right">
							<button
								type="submit"
								disabled={!isDataChanged}
								className="btn btn-primary glow-primary mr-4"
							>
								Save Changes
							</button>
							<Link
								className="btn btn-outline-primary"
								to={`${URL.restaurants}/${slug}`}
							>
								Cancel
							</Link>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default ContactDetails;
